import { Typography } from "antd";
import FlexContainerLayout from "components/atoms/FlexContainerLayout";
import { DataObjectJobHomeOverview, DataSetHomeOverview, DataSetInsightsHomeOverview, SchemaModelHomeOverview } from "containers";
import { useState } from "react";

const { Title } = Typography;

function Home({ tenant }) {
    const [selectedDataSetId, setSelectedDataSetId] = useState(null);
    const [dataSetInsightsRefreshFlag, setDataSetInsightsRefreshFlag] = useState(false);
    const onDataSetSelected = (dataSetId) => {
        setSelectedDataSetId(dataSetId);
        setDataSetInsightsRefreshFlag(!dataSetInsightsRefreshFlag);
    };
    return (
        <FlexContainerLayout contentClassName="flex-1 flex-col flex size-full gap-4">
            <div className="relative flex size-full flex-1 flex-col gap-4 overflow-auto lg:flex-row">
                <div className="relative flex w-full flex-col overflow-auto lg:w-1/2">
                    <SchemaModelHomeOverview tenant={tenant}></SchemaModelHomeOverview>
                </div>
                <div className="relative flex w-full flex-col overflow-auto lg:w-1/2">
                    <DataSetHomeOverview tenant={tenant} onDataSetSelected={onDataSetSelected}></DataSetHomeOverview>
                </div>
            </div>
            <div className="relative flex size-full flex-1 flex-col gap-4 overflow-auto lg:flex-row">
                <div className="relative flex w-full flex-col overflow-auto lg:w-1/2">
                    <DataObjectJobHomeOverview tenant={tenant}></DataObjectJobHomeOverview>
                </div>
                <div className="relative flex w-full flex-col overflow-auto lg:w-1/2">
                    <DataSetInsightsHomeOverview tenant={tenant} dataSetId={selectedDataSetId} refreshFlag={dataSetInsightsRefreshFlag}></DataSetInsightsHomeOverview>
                </div>
            </div>
        </FlexContainerLayout>
    );
}

export default Home;
